import React from "react";

import defaultStyles from "@stadium/ui/src/components/SliderDropdown/main.module.scss";

const SliderContainer = ({ children = null, styles = defaultStyles }) => {
  return <div className={styles.sliderDropdown}>{children}</div>;
};

export default SliderContainer;
